import { useEffect } from 'react';

import { fetchRenewalPlanByStorefront } from '~/actions/vendors/vendorCreditRenewalActions';
import { useAppDispatch, useAppSelector } from '~/reducers';
import { RenewalPlanState } from '~/reducers/vendors/creditRenewalReducer';
import { getIsAuthenticated } from '~/selectors/vendorAccountSelectors';
import { getRenewalPlanByStorefrontUuid } from '~/selectors/vendors/creditRenewalSelectors';
import { getMutex } from '~/util/asyncUtils';
import { StandardLogFn } from '~/util/logger';

import { useToast } from '../useToast';

const useRenewalPlan = (
  storefrontUuid: string,
  isPublished = true
): RenewalPlanState | undefined => {
  const isAuthenticated = useAppSelector(getIsAuthenticated);
  const renewalPlan = useAppSelector((state) =>
    getRenewalPlanByStorefrontUuid(state, storefrontUuid)
  );
  const { negativeToast } = useToast();
  const dispatch = useAppDispatch();
  const fetchMutex = getMutex(`fetchRenewalPlan-${storefrontUuid}`);

  useEffect(() => {
    if (isAuthenticated && !renewalPlan && isPublished && !fetchMutex.locked) {
      fetchMutex.lock();
      dispatch(fetchRenewalPlanByStorefront(storefrontUuid))
        .catch((error) => {
          StandardLogFn(error);
          negativeToast({
            headline: 'Error loading renewal plan. Please try again later or contact support',
          });
        })
        .finally(() => {
          fetchMutex.unlock();
        });
    }
  }, [
    dispatch,
    fetchMutex,
    isAuthenticated,
    isPublished,
    negativeToast,
    renewalPlan,
    storefrontUuid,
  ]);

  return renewalPlan;
};

export default useRenewalPlan;
